import "../assets/Input.css";
import { defineComponent as y, useCssVars as V, unref as b, ref as i, computed as g, openBlock as R, createElementBlock as w, createVNode as B, withDirectives as k, createElementVNode as q, vModelDynamic as E } from "vue";
import { _ as M } from "./Tooltip.vue_vue_type_style_index_0_lang.CsU6T66G.js";
import { b as x } from "./useStore.CNSXUGVb.js";
const C = {
  class: "thn--tool-input",
  ref: "rootRef"
}, D = ["required", "disabled", "type", "name", "error", "placeholder"], d = 10, U = /* @__PURE__ */ y({
  __name: "Input",
  props: {
    placeholder: { default: "" },
    type: {},
    errorMessage: { default: "" },
    required: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(u, { expose: s, emit: p }) {
    V((e) => ({
      "5e3a5074": b(x)(d)
    }));
    const a = u, c = p, t = i(), r = i(), n = g({
      get: () => a.modelValue,
      set: (e) => {
        c("update:modelValue", e);
      }
    });
    function f() {
      r.value.hide();
    }
    function m() {
      var o;
      const {
        top: e,
        left: l
      } = ((o = t.value) == null ? void 0 : o.getBoundingClientRect()) || {};
      r.value.show(a.errorMessage, {
        top: e,
        left: l + d
      });
    }
    function v() {
      const e = t.value.validity.valid;
      return e || m(), e;
    }
    function h() {
      t.value.value = "";
    }
    return s({
      clear: h,
      validate: v
    }), (e, l) => {
      var o;
      return R(), w("div", C, [
        B(M, {
          ref_key: "errorTooltipRef",
          ref: r,
          "auto-hide": 3e3
        }, null, 512),
        k(q("input", {
          role: "textbox",
          tabindex: "0",
          class: "thn--tool-input__input",
          ref_key: "inputRef",
          ref: t,
          required: e.required,
          disabled: e.disabled,
          type: e.type || "email",
          name: e.type || "email",
          error: (o = r.value) == null ? void 0 : o.showing,
          placeholder: e.placeholder,
          "onUpdate:modelValue": l[0] || (l[0] = (_) => n.value = _),
          onMousedown: f
        }, null, 40, D), [
          [E, n.value]
        ])
      ], 512);
    };
  }
});
export {
  U as _
};
//# sourceMappingURL=Input.vue_vue_type_style_index_0_lang.Be_LoQ84.js.map
